// extracted by mini-css-extract-plugin
export default {"input":"styles_input__uFMR0","error":"styles_error__g5DCd","white":"styles_white__XPALj","large":"styles_large__mZF+n"};